import { AuthenticatedUserContext } from "@ngt/forms";
import { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { createSentryAnonymousUser } from "../../utility/errors";

const useSentryUser = () => {
    const authenticatedUser = useContext(AuthenticatedUserContext);
    useEffect(() => {
        // no user, clear sentry user.
        if (!authenticatedUser.data) {
            // set Sentry User back to anonymous.
            Sentry.setUser(createSentryAnonymousUser());
            return;
        }
        // user, set sentry user.
        Sentry.setUser({
            id: authenticatedUser.data.userName,
            username: authenticatedUser.data.userName,
            fullName: authenticatedUser.data.displayName,
            authenticated: true
        })
        return () => {
            // set Sentry User back to anonymous.
            Sentry.setUser(createSentryAnonymousUser());
        }
    }, [authenticatedUser.data])
}

export default useSentryUser;